import React, { useEffect, useState } from "react";
import {
  FaUser,
  FaFileAlt,
  FaFlask,
  FaHospitalAlt,
  FaChevronDown,
  FaChevronRight,
  FaPlus,
  FaMinus,
  FaCircle,
} from "react-icons/fa";
import { Routes, Route, Navigate, useNavigate } from "react-router-dom";
import SetupHospital from "../SetupHospital";
//import styles from "./sidebar.module.css";
  
const Sidebar = ({ role, page, subsection, action }) => {
  const [isOpen, setIsOpen] = useState(true);
  const [submenuOpen, setSubmenuOpen] = useState(0);
  const [activeMenu, setActiveMenu] = useState(page);
  const [activeSubMenu, setActiveSubMenu] = useState(subsection);

  const navigate = useNavigate();

  const toggleSidebar = () => {
    setIsOpen(!isOpen);
    if (isOpen) {
      setSubmenuOpen(0);
    }
  };

  const handleMenuClick = (menu) => {
    if (!isOpen) {
      setIsOpen(true);
    }

    setActiveMenu(menu);
    toggleSubmenu(0);
    // setActiveSubMenu("");
  };

  const toggleSubmenu = (name) => {
    setSubmenuOpen((prev) => (prev === name ? 0 : name));
  };
 
  const renderContent = () => { 
    if (activeMenu == "setting"){
      return <SetupHospital/>
    }
  };

  return (
    <div style={styles.wrapper} className="lg:!mt-0 mt-[30px]">
      <div
        style={{
          ...styles.sidebar,
          width: isOpen ? "263px" : "59px",
        }}
        onMouseEnter={() =>
          isOpen === false && window.innerWidth >= 768 && setIsOpen(true)
        }
        // onMouseLeave={() =>
        //   isOpen === true && window.innerWidth >= 768 && setIsOpen(false)
        // }
      >
        <div
          style={{
            ...styles.header,
            justifyContent: isOpen ? "space-between" : "center",
            padding: isOpen ? "0px 15px 0px 15px" : "",
          }}
        >
          {isOpen && <p style={styles.headerText}>สำหรับโรงพยาบาล</p>}
          <button
            style={styles.toggleButton}
            onClick={toggleSidebar}
            aria-label={isOpen ? "Close Sidebar" : "Open Sidebar"}
          >
            {isOpen ? (
              <div className="flex justify-center items-center text-[30px] w-[40px] h-[40px]">
                -
              </div>
            ) : (
              <div className="flex justify-center items-center text-[30px] w-[40px] h-[40px]">
                +
              </div>
            )}
          </button>
        </div>
        <div style={styles.menu}>
          {/* menu 1 */}
          <div
            style={styles.menuItem}
            onClick={() => {
              handleMenuClick("setting");
              toggleSubmenu(0);
              setActiveSubMenu("");
            }}
          >
            <div
              className="flex flex-row items-center gap-[10px] justify-start w-full pl-3 pr-3 active:h-[42px] active:rounded-[6px]"
              style={{
                justifyContent: isOpen ? "start" : "center",
                backgroundColor:
                  activeMenu === "hospitalsetting" ? "#00917E" : "",
                color: activeMenu === "hospitalsetting" ? "#fff" : "",
                height: activeMenu === "hospitalsetting" ? "42px" : "",
                borderRadius: activeMenu === "hospitalsetting" ? "6px" : "",
              }}
            >
              <FaHospitalAlt style={{ width: "18px" }} />
              {isOpen && <span style={styles.text}>ตั้งค่าโรงพยาบาล</span>}
            </div>
          </div>
        </div>
      </div>

      <div style={styles.container}>{renderContent()}</div>
    </div>
  );
};

const styles = {
  wrapper: {
    display: "flex",
    width: "100%",
    backgroundColor: "#f4f4f4",
  },
  sidebar: {
    background: "#F5FFFA",
    color: "#00917E",
    transition: "width 0.3s",
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
    boxShadow: "2px 0 5px rgba(0, 0, 0, 0.1)",
    paddingTop: "10px",
  },
  container: {
    flex: 1,
    padding: "20px",
    whiteSpace: "nowrap",
    overflow: "auto",
    backgroundColor: "white",
  },
  header: {
    display: "flex",
    alignItems: "center",
    height: "50px",
  },
  headerText: {
    fontSize: "16px",
    fontWeight: "600",
    color: "#00917E",
    lineHeight: "42px",
    fontFamily: "Prompt, sans-serif",
  },
  toggleButton: {
    background: "#F5FFFA",
    color: "#00917E",
    border: "1px solid #93D3B1",
    borderRadius: "6px",
    cursor: "pointer",
    padding: "2px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  menu: {
    display: "flex",
    flexDirection: "column",
    padding: "10px 0",
  },
  menuItem: {
    display: "flex",
    alignItems: "center",
    padding: "0 5px",
    justifyContent: "space-between",
    height: "50px",
    cursor: "pointer",
  },
  submenu: {
    borderLeft: "2px solid #93D3B1",
    listStyleType: "disc",
    color: "#00917E",
  },
  submenuItem: {
    display: "flex",
    alignItems: "center",
    padding: "5px 0",
    height: "50px",
    cursor: "pointer",
    transition: "background-color 0.3s",
    margin: "0px 5px",
  },
  submenuItemActive: {
    backgroundColor: "#00917E",
    color: "#fff",
    borderRadius: "6px",
  },
  text: {
    fontSize: "14px",
    fontWeight: "400",
    whiteSpace: "nowrap",
  },
};

export default Sidebar;
